import React from 'react';

// Shared rich-text renderers for inline tags in FormatJS messages on the
// privacy/terms page. Keeping them here means we don't redeclare the same
// `values={{ strong, em, a, ... }}` blob on every <FormattedMessage>.
export const inlineRichText = {
  strong: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
  em: (chunks: React.ReactNode) => <em>{chunks}</em>,
  fountainPrivacyLink: (chunks: React.ReactNode) => (
    <a href="https://fountain.com/privacy" target="_blank" rel="noreferrer">
      {chunks}
    </a>
  ),
};

export const mailtoRichText = (supportContact: string) => ({
  ...inlineRichText,
  supportLink: (chunks: React.ReactNode) => (
    <a href={`mailto:${supportContact}`}>{chunks}</a>
  ),
  privacyMailLink: (chunks: React.ReactNode) => (
    <a href="mailto:privacy@fountain.com">{chunks}</a>
  ),
});
